import { IAdminActionTypesState } from './AdminActionTypes.types';

export enum ActionTypes {
    ADMINACTIONTYPES = 'ADMINACTIONTYPES',
    ADMINACTIONTYPES_SET_REDIRECTION_STATE = 'ADMINACTIONTYPES_SET_REDIRECTION_STATE'
}

export type IAdminActionTypesActions = ISetAdminActionTypesRedirectionAction;

export interface ISetAdminActionTypesRedirectionAction {
    type: ActionTypes.ADMINACTIONTYPES_SET_REDIRECTION_STATE;
    data: IAdminActionTypesState;
}
